import {Component, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, Validators} from "@angular/forms";
import {AuthService} from "../../utility/services/auth.service";
import {ErrorResponse} from "../../utility/interfaces/error-response";
import {catchError, combineLatestWith, EMPTY, filter} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthStatus} from "../../utility/enums/auth-status";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {LOGO_URL} from "../../utility/constants/api.constants";
import {loadCart} from "../../trunks/+state/trunk.actions";
import {Store} from "@ngrx/store";

@UntilDestroy()
@Component({
    selector: 'knust-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent {
  logoPath = LOGO_URL;

  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  });

  error: ErrorResponse | undefined = undefined;

  constructor(private fb: FormBuilder,
              public auth: AuthService,
              private router: Router,
              private store: Store,
              private route: ActivatedRoute) {
    this.auth.currentStatus.pipe(
      untilDestroyed(this),
      filter(status => status === AuthStatus.LOGGED_IN),
      combineLatestWith(auth.appInitCompleted)
    ).subscribe(([status, appInitCompleted]) => {
      const previousPage = this.route.snapshot.queryParamMap.get('prev');

      if (appInitCompleted) {
        this.router.navigate([previousPage ?? '']);
      } else {
        this.router.navigate(['stammdaten']);
      }
    });
  }

  login() {
    const { username, password } = this.loginForm.value;

    if (username && password) {
      this.error = undefined;

      this.auth.login(username, password).pipe(
        catchError(err => {
          this.error = err.error;
          return EMPTY;
        }),
        untilDestroyed(this),
      ).subscribe(() => this.store.dispatch(loadCart()));
    }
  }

  register() {
    const { username, password } = this.loginForm.value;

    if (username && password) {
      this.auth.register(username, password).pipe(
        untilDestroyed(this),
      ).subscribe();
    }
  }
}
